require('../scss/connection.scss');
// require('bootstrap-sass/assets/stylesheets/_bootstrap.scss');
require('../scss/utils/bootstrap/bootstrap.min.css');

require('animate.css/animate.min.css');
var $ = require('jquery');
var common = require('./common');

var lang='';
//var icon = require('../img/favicon.jpg');
//console.log(icon);
//alert('hello world');

$( document ).ready(function() {

    lang = common.initChangePage();

    if(lang == 'en'){
        $('#CUNav').addClass('f-fHNLTP63ME');
    }else{
        $('#CUNav').addClass('f-fZHBold');
        $('.tit').addClass('f-fZHBold');
    }
    $('#connection').addClass('active');
    // console.log(1);
    //$('.radius').hover(function(){
    //    $(this).parents('.function').find('.bottom').show();
    //
    //},function(){
    //    $(this).parents('.function').find('.bottom').hide();
    //
    //});
    $('.function').find('.bottom').show();



});







// WEBPACK FOOTER //
// ./src/connection.js